(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["singh-carpet-catalog"]) return;
  try {
    
document.querySelectorAll('[data-singh-catalog]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const cards=Array.from(root.querySelectorAll('[data-card]')).map((el,index)=>{
const tags=JSON.parse(el.dataset.tags),values=prefix=>tags.filter(t=>t.startsWith(prefix)).map(t=>t.slice(prefix.length));
return {el,index,price:Number(el.dataset.price),title:el.dataset.title,quote:tags.includes('Price unit confirmation required'),pile:values('Pile: '),range:values('Range: '),colour:values('Colour group: '),width:values('Roll width: '),fitting:tags.includes('Fitting: Free fitting offer')?[root.dataset.freeLabel]:[root.dataset.separateLabel]};
});
const groups=Array.from(root.querySelectorAll('[data-facet]')),selected=new Map();
groups.forEach(group=>{
const facet=group.dataset.facet,values=[...new Set(cards.flatMap(c=>c[facet]))].sort((a,b)=>a.localeCompare(b));
const addChoice=(value,text,disabled=false)=>{
const label=document.createElement('label'),input=document.createElement('input'),span=document.createElement('span');
label.className='singh-catalog-choice';input.type='checkbox';input.value=value;input.disabled=disabled;input.dataset.filterChoice=facet;span.textContent=text;label.append(input,span);group.append(label);
};
values.forEach(value=>addChoice(value,value));
if(facet==='pile'&&!values.includes('Loop pile'))addChoice('Loop pile',root.dataset.loopLabel,true);
});
const min=root.querySelector('[data-min-price]'),max=root.querySelector('[data-max-price]'),sort=root.querySelector('[data-sort]'),grid=root.querySelector('[data-grid]'),count=root.querySelector('[data-count]');
const lower=root.querySelector('[data-price-lower]'),upper=root.querySelector('[data-price-upper]'),priceValue=root.querySelector('[data-price-value]'),priceFill=root.querySelector('[data-price-fill]');
const ceiling=Math.max(1,...cards.filter(c=>!c.quote).map(c=>Math.ceil(c.price/100)));
const money=new Intl.NumberFormat(document.documentElement.lang||'en-GB',{style:'currency',currency:'GBP',minimumFractionDigits:0,maximumFractionDigits:2});
[lower,upper,min,max].forEach(input=>input.max=String(ceiling));min.placeholder='0';max.placeholder=String(ceiling);
function syncPrice(){
const low=Math.min(ceiling,Math.max(0,Number(min.value)||0)),high=Math.min(ceiling,Math.max(low,max.value===''?ceiling:Number(max.value)));
lower.value=String(low);upper.value=String(high);lower.setAttribute('aria-valuetext',money.format(low));upper.setAttribute('aria-valuetext',money.format(high));
lower.setAttribute('aria-valuemax',String(high));upper.setAttribute('aria-valuemin',String(low));
lower.style.zIndex=low>=ceiling?'3':'1';
priceFill.style.left=(low/ceiling*100)+'%';priceFill.style.right=(100-high/ceiling*100)+'%';priceValue.textContent=money.format(low)+' – '+money.format(high)+' / m²';
}
lower.addEventListener('input',()=>{const value=Math.min(Number(lower.value),Number(upper.value));min.value=value===0?'':String(value);update();});
upper.addEventListener('input',()=>{const value=Math.max(Number(upper.value),Number(lower.value));max.value=value===ceiling?'':String(value);update();});
[min,max].forEach(input=>input.addEventListener('change',()=>{
if(input.value!=='')input.value=String(Math.min(ceiling,Math.max(0,Number(input.value)||0)));
if(min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value)){if(input===min)max.value=min.value;else min.value=max.value;}update();
}));
const panel=root.querySelector('[data-filter-panel]'),dialog=root.querySelector('[data-filter-dialog]'),trigger=root.querySelector('[data-filter-open]'),activeCount=root.querySelector('[data-active-count]');
trigger.addEventListener('click',()=>dialog.showModal());
root.querySelector('[data-filter-close]').addEventListener('click',()=>dialog.close());
root.querySelector('[data-filter-apply]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();});
function update(){
syncPrice();
const priceActive=min.value!==''||max.value!=='';
const low=min.value===''?0:Number(min.value)*100,high=max.value===''?Infinity:Number(max.value)*100;
const sorted=[...cards].sort((a,b)=>Number(a.quote)-Number(b.quote)||(sort.value==='name'?a.title.localeCompare(b.title):sort.value==='price-down'?b.price-a.price:a.price-b.price)||a.index-b.index);
let n=0;sorted.forEach(c=>{c.el.hidden=![...selected].every(([facet,value])=>c[facet].includes(value))||c.price<low||c.price>high||(priceActive&&c.quote);n+=!c.el.hidden;grid.append(c.el);});
const applied=selected.size+Number(priceActive);activeCount.textContent=String(applied);activeCount.hidden=applied===0;root.querySelector('[data-result-count]').textContent='('+n+')';
count.textContent=n+' '+count.dataset.label;root.querySelector('[data-empty]').hidden=n!==0;
}
root.querySelector('[data-clear]').addEventListener('click',()=>{selected.clear();root.querySelectorAll('[data-filter-choice]').forEach(input=>input.checked=false);min.value='';max.value='';sort.value='price-up';update();});
root.querySelector('.singh-catalog-controls').addEventListener('change',event=>{
const input=event.target;if(input.matches('[data-filter-choice]')){const facet=input.dataset.filterChoice;if(input.checked){selected.set(facet,input.value);root.querySelectorAll('[data-filter-choice]').forEach(other=>{if(other!==input&&other.dataset.filterChoice===facet)other.checked=false;});}else selected.delete(facet);}update();
});
[min,max].forEach(el=>el.addEventListener('input',update));
const defaultFitting=Array.from(root.querySelectorAll('[data-filter-choice]')).find(input=>input.dataset.filterChoice==='fitting'&&input.value===root.dataset.freeLabel);
if(defaultFitting){defaultFitting.checked=true;selected.set('fitting',root.dataset.freeLabel);}
sort.value='price-up';panel.hidden=false;update();
});

  } catch(e) { console.error(e); }
})();
})();
